// ============================================================
// NEWS — Blog posts and announcements
// ============================================================
//
// Fields: title, date, cat (category for filtering), url
// Categories must match the filter tabs: "Portfolio News", "Insights"

export const NEWS = [
  {
    title: "Introducing ether.fi Ventures",
    date: "2025",
    cat: "Insights",
    url: "https://blog.ether.fi",
  },
  {
    title: "Hyperbeat Secures $5.2M Seed Round",
    date: "2025",
    cat: "Portfolio News",
    url: "https://www.coindesk.com/tech/2025/08/15/hyperbeat-secures-usd5-2m-backing-from-ether-fi-electric-capital",
  },
];
